import { Button, Form, message, Modal, Space, TimePicker } from "antd";
import Presets from "../../../extensions/presets";
import { useState } from "react";
import { cnvString2Time, fmtDate, fmtTime } from "../../../extensions/utils";
import { serverFetch } from "../../../server";

const CalendarDayEdit = ({ calendarId, dates, items, onClose }) => {
  const [loading, setLoading] = useState(false);
  const [newItems, setNewItems] = useState(items.map(i => ({...i, start: cnvString2Time(i.start), finish: cnvString2Time(i.finish)})));
  const [form] = Form.useForm();

  const onSave = () => {
    setLoading(true);
    const items = newItems.map(i => ({dayId: 0, start: fmtTime(i.start), finish: fmtTime(i.finish)}))
    serverFetch("calendar/cnt/Paste", { method: "POST", bodyData: { calendarId, dates, source: items } })
      .then(() => onClose(true))
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  const onChangeItem = (idx, value) => {
    const xItems = [...newItems];
    xItems[idx] = {...xItems[idx], ...value};
    setNewItems(xItems);
  }

  const divItems = [
    newItems.map((item,idx) => <Form.Item key={idx}>
      <Space>
        <Form.Item label="Начало"><TimePicker format="HH:mm" value={item.start} onChange={e => onChangeItem(idx, {start: e})}/></Form.Item>
        <Form.Item label="Окончание"><TimePicker format="HH:mm" value={item.finish} onChange={e => onChangeItem(idx, {finish: e})}/></Form.Item>
        <Form.Item><Button onClick={() => setNewItems([...newItems.slice(0, idx), ...newItems.slice(idx + 1)])}>Удалить</Button></Form.Item>
      </Space>
    </Form.Item>)
  ]

  const noSave = newItems.find(i => !i.start || !i.finish);
  const title = <div className="calendar-day-edit-title">
    <div>График</div>
    {dates.map(i => <div className="calendar-day-edit-date" key={i}>{fmtDate(i)}</div>)}
  </div>;
  return<Modal onCancel={() => onClose(false)} {...Presets.modalInfo} title={title}>
    <Form form={form} labelCol={{ span: 3 }} wrapperCol={{ span: 24 }} colon={false} disabled={loading}>
      {divItems}
      <Form.Item label=" "><Space>
        <Button onClick={() => setNewItems([...newItems, { dayId: 0 }])}>Добавить интервал</Button>
        <Button onClick={onSave} disabled={noSave}>Сохранить</Button>
        <Button onClick={() => onClose(false)}>Закрыть</Button>
      </Space></Form.Item>
    </Form>
  </Modal>
}

export default CalendarDayEdit;